export default __webpack_public_path__ + "static/media/alba-history-2024.5962ea30.jpg";